import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class EstateTaxFormUsMeta extends BaseEntityModel {
  parentId?: number;
  irsFidForms?: boolean;
  irsTermForms?: boolean;
  yearEnd?: string;
  extensionDate?: string;
  taxYear?: number;
  irsAmount?: number;

  constructor(model: Partial<EstateTaxFormUsMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.irsFidForms = model.irsFidForms;
    this.irsTermForms = model.irsTermForms;
    this.yearEnd = model.yearEnd;
    this.extensionDate = model.extensionDate;
    this.taxYear = model.taxYear;
    this.irsAmount = model.irsAmount;
  }
}
